import { ChangeDetectionStrategy, Component, inject, signal, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MessageModule } from 'primeng/message';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '@cosmos/angular/utils';

@Component({
  selector: 'cosmos-verify-email',
  imports: [TranslatePipe, RouterModule, MessageModule, AuthLayoutComponent, ButtonModule],
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyEmailComponent implements OnInit {
  protected readonly validating = signal(false);
  protected readonly error = signal(false);
  protected readonly validateText = signal('');
  private token: string;
  
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);
  private readonly translateService = inject(TranslateService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
    })

    const body = {token: this.token};

    this.validateText.set(this.translateService.instant('signup.validating-token'));
    
    this.http.post(`${environment.API_URL}/token/validate-email`, body, {observe: 'response'}).subscribe({
          next: () => {
            this.validateText.set(this.translateService.instant('signup.account-active'));
            this.validating.set(false);
            this.authService.updateCurrentUser().subscribe();
            // Wait timeout of 3 seconds and redirect to login
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 3000);
          },
          error: (e) => { 
            this.validateText.set(this.translateService.instant('signup.validate-error'));
            this.validating.set(false);
            this.error.set(true);
          }
        })
  }
}
